module.exports = __webpack_public_path__ + "static/media/VectorPointAndamento18.b1c619a9.svg";